

















































// Importing components
import BaseSortIcons from '@/ui/BaseSortIcons.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import BaseButton from '@/ui/BaseButton.vue';
// Importing functions
import {deleteUser} from '@/ts/users/delete-user';
import {getUsers} from '@/ts/users/get-users';

export default {
    name: 'TheTableUsers',
    components: {
        BaseButton,
        BaseLoadingAnimation,
        BaseSortIcons,
    },
    props: {},
    data() {
        return {};
    },
    methods: {
        fireModal(id) {
            this.$swal.fire({
                title: 'Внимание!',
                text: 'Това действие е необратимо, желаете ли да продължите?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Отказ',
                confirmButtonText: 'Изтриване',
            }).then((result) => {
                if (result.value) {
                    deleteUser(id).then(() => {
                        this.$swal.fire(
                            'Изтриването успешно!',
                            '',
                            'success',
                        );
                        const index = this.$store.state.response.response.findIndex((item) => item.id === id);
                        this.$store.state.response.response.splice(index, index);
                    });
                }
            });
        },
        sort() {
            this.$store.dispatch('setLoadingOn');
            getUsers().then(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
    },
};
